import { createClient } from '@supabase/supabase-js'
import type { Database } from '../../types/supabase'

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL ?? 'https://pknsrgukddhtpiuvekth.supabase.co'
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY ?? ''

// Dedicated admin client. Uses the public ANON key (NOT the service role) and
// relies on RLS + is_platform_admin() (mig 178) for cross-tenant access.
//
// It keeps its OWN auth session under a separate storageKey so the platform
// admin's login is isolated from the main tenant app's `supabase` session.
// They previously shared one global session: signing into the tenant app (or
// having an existing tenant session) clobbered the admin's token, so admin
// pages then queried as that tenant user and cross-tenant reads collapsed to
// the single tenant that user belongs to — e.g. Overview counting 1 tenant
// instead of all of them. Isolating the session fixes that in both directions.
export const adminSupabase = createClient<Database>(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: false,
    storageKey: 'palstro-admin-auth',
  },
})

// Shorthand for table access via the isolated admin session.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const adb = (table: string): any => (adminSupabase as any).from(table)

// Log an admin action via the isolated admin client. RLS policy
// `platform_audit_logs_platform_admin` (mig 178) permits authenticated
// platform admins to write to platform_audit_logs.
export async function logAdminAction(
  adminId: string,
  action: string,
  details: Record<string, unknown>,
  ipAddress?: string,
) {
  await (adminSupabase.from('platform_audit_logs') as any).insert({
    admin_id: adminId,
    action,
    details,
    ip_address: ipAddress ?? null,
  })
}
